import React from 'react';
import './Header.css';
import Logo from './logo.png';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search'
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import {useStateValue} from './StateProvider';
import {auth} from './firebase';
import './About'

var audio = new Audio();
audio.src="yo.mp3";
function Header() {
    const [{basket, user}, dispatch] =useStateValue();

    const login = () =>{
        if (user){
            auth.signOut();
        }
    }

    return (
        <nav className="header">
            <Link to="/">
                <img className="header__logo" src={Logo} alt=""/>
            </Link>
            
            
            <div className="header__nav">
            <Link to={!user && "/login"} className="header__link">
                    <div onClick={login} className="header__option">
                        <span className="header__optionLineOne">Whats up ,{user?.email}</span>
                    <span className="header__optionLineTwo">{user?"Sign Out":"Sign in"}</span>
                    </div>
            </Link>
            <Link to={!user && "/about"} className="header__link">
                    <div className="header__option">
                        <span className="header__optionLineOne"></span>
                    <span className="header__optionLineTwo"></span>
                    </div>
            </Link>
              <Link to="/checkout" className="header__link">
                    <div className="header__optionBasket">
                        <AddShoppingCartIcon/>
    <span className="header__optionLineTwo header__basketCount">{basket?.length}</span>
                    </div>
            </Link>
            <Link to={!user && "/"} className="header__link">
                    <div onClick={login} className="header__option">
                        <span className="header__optionLineOne"></span>
                    <span className="header__optionLineTwo"></span>
                    </div>
            </Link>
            </div>
        </nav>
    )
}

export default Header
